import { useTranslation } from 'react-i18next';
import { version } from "../../../package.json";

const Footer = () => {
    const { t } = useTranslation();
    return (
        <div className="sm:text-left p-6 mt-auto flex justify-between items-center flex-col sm:flex-row">
            <span>2022 - {new Date().toLocaleDateString('en', { year: '2-digit' })} © TargetScore {t('ALL_RIGHTS_RESERVED')}.</span>
            <div className='flex flex-row items-center justify-center gap-4'>
                <ul className='flex flex-row gap-4'>
                    <li><a className='hover:underline no-underline text-primary' href="https://docs.targetscore.com/docs/legal/terms-of-service" target='_blank'>Terms of Service</a></li>
                    <li><a className='hover:underline no-underline text-primary' href="https://docs.targetscore.com/docs/legal/donation-policy" target='_blank'>Donation Policy</a></li>
                </ul>
                <span className="mr-4 text-gray-600 text-xs">v{version}</span>
            </div>
        </div>
    );
};

export default Footer;
